<template>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" v-if="this.modalMaterial.action === 'create'">Create Task</h5>
                <h5 class="modal-title" id="exampleModalLabel" v-else-if="this.modalMaterial.action === 'update'">Update Task</h5>
                <h5 class="modal-title" id="exampleModalLabel" v-else-if="this.modalMaterial.action === 'delete'">Delete Task</h5>
                <h5 class="modal-title" id="exampleModalLabel" v-else-if="this.modalMaterial.action === 'error'">Error</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="buttonClose"></button>
            </div>
            <form @submit.prevent="submitForm()" v-if="(this.modalMaterial.action != 'delete') && (this.modalMaterial.action != 'error')">
                <div class="modal-body">
                        <div class="mb-3">
                            <label for="exampleInputEmail1" class="form-label">Title</label>
                            <input type="text" class="form-control" v-model="titles">
                        </div>
                        <div class="mb-3" v-if="this.modalMaterial.action === 'update'">
                            <!-- <label for="exampleInputEmail1" class="form-label">category</label>
                            <input type="text" class="form-control" v-model="categories">
                            <select v-model="category">
                                <option value="name" v-for="(name, id) in category_list" :key="id">{{id}}</option>
                            </select> -->
                        </div>
                        <div class="mb-3" v-else-if="this.modalMaterial.action === 'create'">
                            <input type="hidden" v-model="category">
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary" v-if="this.modalMaterial.action === 'create'">Create</button>
                    <button type="submit" class="btn btn-primary" v-else-if="this.modalMaterial.action === 'update'">Update</button>
                </div>
            </form>
            <div v-else-if="(this.modalMaterial.action === 'delete')">
                <div class="modal-body">
                    Are you sure want to delete this task ?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-danger" @click="deleteTask">Yes</button>
                </div>
            </div>
            <div v-else-if="(this.modalMaterial.action === 'error')">
                <div class="modal-body">
                    <div>
                        You cannot perform this action
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>

export default ({
    name: 'modal',
    props: ["modalMaterial"],
    data(){
        return {
            title: this.titles,
            category: this.categories,
            category_list : ['backlog','todo','doing','completed']
        }
    },
    methods : {
        submitForm() {
            if (this.modalMaterial.action === 'create') {
                let data = {
                    title : this.title,
                    category: this.categories
                }
                this.$emit('create-new-todo',data)
            }else if(this.modalMaterial.action === 'update'){
                let data = {
                    id: this.modalMaterial.id,
                    title : this.title,
                    category: this.category
                }
                this.$emit('edit-todo',data)
            }
            this.title = ''
            this.category = ''
            this.$refs.buttonClose.click()
        },
        deleteTask() {
            let id=this.modalMaterial.id
            this.$emit('delete-task',id)
            this.$refs.buttonClose.click()
        },
    },
    updated (){
        // category() {
            if (this.modalMaterial.action === 'create') {
                this.category = this.modalMaterial.category
            }else{
                this.category = this.modalMaterial.category
                this.title = this.modalMaterial.title
                // console.log(this.modalMaterial.category)
                // console.log(this.modalMaterial.title)
            }
        // }
    },
    beforeUpdate(){
        this.category = this.modalMaterial.category
        // console.log(this.modalMaterial.category)
    },
    computed : {
        categories:{
            get : function() {
                if (this.modalMaterial.action === 'create') {
                    return this.modalMaterial.category
                }else{
                    return this.modalMaterial.category
                }
            },
            set : function( val ) {
                this.categories = val
            }
        },
        titles:{
            get() {
                if (this.modalMaterial.action === 'update') {
                    return this.modalMaterial.title
                }
            },
            set(val) {
                this.title = val
                // console.log(val,'val')
            }
        }
    }
})
</script>

<style scoped>

</style>